export const planList = [
    {
        id: 0,
        key: "free_b2c",
        title: "Free B2C",
        button: "Registration",
        price: 0,
        items: [
            "Profile Page",
            "Radio Monitoring of Top 10 songs",
            "Discover similar tracks",
            "Create Playlists of your favorite tracks",
            "Free access to CuRadio for 2 weeks",
        ],
    },
    {
        id: 1,
        key:"paid_b2c",
        title: "Paid B2C",
        button: "3$/month",
        price: 3,
        items: [
            "Profile Page",
            "Radio Monitoring of Top 10 songs",
            "Discover similar tracks",
            "Create Playlists of your favorite tracks",
            "Free access to CuRadio",
        ],
    },
    {
        id: 2,
        key:"basic_b2b",
        title: "B2B Basic",
        button: "9.99$/month",
        price: 9.99,
        items: [
            "Profile Page",
            "Footprinting & Watermarking of content",
            "Radio Monitoring of 10 Songs",
            "Monthy change of songs to be monitored",
            "Weekly reports",
            "Discover similar tracks to own content",
            "Create Playlists from content",
            "Professional accounting",
        ],
    },
    {
        id: 3,
        key:"medium_b2b",
        title: "B2B Medium",
        button: "15.99$/month",
        price: 15.99,
        items: [
            "Profile Page",
            "Footprinting & Watermarking of content",
            "Radio Monitoring of 10 Songs",
            "Monthy change of songs to be monitored",
            "Real time reports",
            "Discover similar tracks to own content",
            "Create Playlists from content",
            "Professional accounting",
            "Shop",
            "Ticketing Service",
        ],
    },
    {
        id: 4,
        key:"premium_b2b",
        title: "B2B Premium",
        button: "24.99$/month",
        price: 24.99,
        items: [
            "Profile Page",
            "Footprinting & Watermarking of content",
            "Radio Monitoring of 10 Songs",
            "Weekly change of songs to be monitored",
            "Real time reports",
            "Radio promo contacts",
            "Radio Monitoring with revenue accounting",
            "YT Ads on 3rd party sites",
            "Accounting with chartmetrics",
            "Shop",
            "Blockchain",
            "NFTs",
            "Ticketing Service",
        ],
    },
];